var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading && _vm.swapDetails)?_c('SwapOverview',{attrs:{"swap-details":_vm.swapDetails,"show-action-buttons":false}}):(_vm.isLoading)?_c('div',{staticClass:"spinner-container"},[_c('ASpinner')],1):_c('div',{staticClass:"broken-swap"},[_vm._v(" "+_vm._s(_vm.$t('swap_overview_swap_not_available'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }